module.exports = __webpack_public_path__ + "assets/d56644e81a517f7eebde35b7dfe3df87.mp3";